import React from 'react'

export interface HeaderContextProps {
  portalRef?: React.MutableRefObject<HTMLDivElement | null>
  // The element behind portalRef, as state so a portal can read it during render.
  portalElement?: HTMLDivElement | null
  setPortalRef: (ref: React.RefObject<HTMLDivElement>) => void
}
export const HeaderContext = React.createContext<HeaderContextProps>({ setPortalRef: () => {} })
